import { useOnboardMember } from "@/hooks/use-organisation";
import { useGetActiveSubscriptionPlans } from "@/hooks/use-subscription";
import { useActiveTenancy, useUser } from "@wacht/tanstack-router";
import { useEffect, useRef } from "react";

export const CustomerIO = () => {
  const { user, loading: userLoading } = useUser();
  const { orgMembership, loading: orgMembershipLoading } = useActiveTenancy();
  const { data: activeSubscriptionPlansData } = useGetActiveSubscriptionPlans();
  const hasTriggered = useRef(false);
  const { data: onBoardedMember } = useOnboardMember();

  useEffect(() => {
    // console.log({ user, organization, activeSubscriptionPlansData });
    if (userLoading || orgMembershipLoading) return;
    return;

    if (window.cioanalytics && !hasTriggered.current) {
      const currentUser = user!;
      const currentOrganisation = orgMembership!.organization!;

      const isOwner =
        onBoardedMember?.organisation.owner._id === onBoardedMember?.user._id;

      window.cioanalytics?.identify(user.id!, {
        email: currentUser.primary_email_address!.email,
        name: currentUser.first_name + " " + currentUser.last_name,
        firstName: currentUser.first_name,
        lastName: currentUser.last_name,
        organizationName: currentOrganisation.name,
        organizationId: currentOrganisation.id,
        isOwner: isOwner,
      });

      const subscriptions = activeSubscriptionPlansData?.map((plan) => ({
        cycle: plan.interval,
        status: plan.status,
        plans: plan.plans.map((p) => ({
          name: p.planId?.planName || p.addonPlanId?.name,
          isCustom: p.isCustomPlan,
          quantity: p.quantity,
          pendingRequests: p.pendingRequests,
        })),
      }));

      window.cioanalytics?.group(currentOrganisation.id, {
        name: currentOrganisation.name,
        members: currentOrganisation.member_count,
        owner: onBoardedMember?.organisation.owner,
        subscriptions: subscriptions,
        createdAt: currentOrganisation.created_at,
      });

      hasTriggered.current = true;
    }
  }, [
    user,
    orgMembership,
    activeSubscriptionPlansData,
    onBoardedMember,
    userLoading,
    orgMembershipLoading,
  ]);

  return null;
};
